import axios from 'axios';
import cfac22 from '../cfac22';

export const postClientCrashLog = async (payload) => {
  const endpoint = `${cfac22('API_HOST_V2')}/clientCrashLogs`;

  return axios.post(endpoint, payload, {
    withCredentials: true,
    headers: {
      'Full-Url': window.location.href,
    },
  });
};
